import { useAppQuery } from 'core/query/hooks/useAppQuery';
import { FIVE_MINUTES } from '@constants';
import {
  getIntegrationCountsApi,
  IntegrationCountsResponse,
} from 'IntegrationModule/api/getIntegrationCountsApi';
import { integrationQueryKeys } from './integrationQueryKeys';

/**
 * Fetches active integration counts per targetService, aggregated across all
 * tenants/realms. Backs the Galaxy sidebar count badges.
 *
 * Sourced from galaxy-server's `search_team` JSONB column — fast local query.
 * Staleness bounded by the weekly refresh cron + fire-and-forget refresh on
 * provisioning / state transitions.
 */
export const useIntegrationCountsQuery = () => {
  const { data, ...query } = useAppQuery<IntegrationCountsResponse>({
    queryKey: integrationQueryKeys.list({
      identifier: 'useIntegrationCountsQuery',
    }),
    queryFn: async ({ token }) => {
      const response = await getIntegrationCountsApi({
        params: undefined,
        token,
      });
      return (response.data ?? {}) as IntegrationCountsResponse;
    },
    staleTime: FIVE_MINUTES,
    refetchOnWindowFocus: false,
  });

  return {
    counts: data ?? {},
    ...query,
  };
};
